<template>
  <div
    class="plv-iar-product-bubble__bubble-main"
    @click="onClick"
  >
    <!-- 热卖中 -->
    <HotTimeLabel
      v-show="hotEffectEnabled && hotTimes >= 1"
      :good="good"
      :hot-effect-tip-option="hotEffectTipOption"
      :hot-times="hotTimes"
      :last-hot-times="lastHotTimes"
    />
    <div class="plv-iar-product-bubble__bubble—container">
      <!-- 商品图片 -->
      <div
        class="plv-iar-product-bubble__cover"
        :class="{
          'plv-iar-product-bubble__nocover': !good.cover,
          'plv-iar-product-bubble__margin': good.showId && !good.cover
        }"
      >
        <img v-if="good.cover" :src="ossCompress(good.cover, { width: 300 })" :alt="good.name" />
        <div v-if="isSoldOut" class="plv-iar-product-bubble__cover__sold-out">
          - {{ iarTrans('product.soldOut') }} -
        </div>
        <span v-if="good.showId && good.explainStatus !== 'explaining'" class="plv-iar-product-bubble__cover__number">{{ good.showId }}</span>
        <div
          v-if="good.explainStatus === 'explaining'"
          class="plv-iar-product-bubble__explaining"
          :class="{ 'plv-iar-product-bubble__explaining--nocover': !good.cover }"
        >
          <img class="plv-iar-product-bubble__explaining__icon" src="../list/imgs/live.gif" />
          <span>{{ iarTrans('product.explaining') }}</span>
        </div>
        <!-- 商品标签 -->
        <span v-if="labels[0]" class="plv-iar-product-bubble__content__labels">
          <i>{{ labels[0] }}</i>
        </span>
      </div>

      <div class="plv-iar-product-bubble__content">
        <!-- 商品名称 -->
        <div
          :title="good.name"
          class="plv-iar-product-bubble__content__name"
        >
          <span>{{ good.name }}</span>
        </div>

        <template v-if="good.productType === 'normal'|| good.priceType === 'CUSTOM'">
          <div class="plv-iar-product-bubble__content_custom_price">
            <!-- 待开价 -->
            <span v-if="shouldHidePrice">
              <span class="plv-iar-product__item__price-symbol">¥</span>
              <span class="plv-iar-product__item__price-value plv-font-din-pro-regular">{{ hidePriceQuestionMarks }}</span>
              <span class="plv-iar-product__item__price-tag plv-font-din-pro-regular">{{ iarTrans('product.hidePrice') }}</span>
            </span>
            <!-- 自定义价格显示区 -->
            <span v-else-if="good.priceType === 'CUSTOM'" :title="good.customPrice">{{ good.customPrice }}</span>
            <!-- 常规商品价格显示区域 -->
            <span v-else>{{ realPrice(good.realPrice) }}</span>
          </div>
        </template>

        <div class="plv-iar-product-bubble__content__other">
          <div class="plv-iar-product-bubble__content__price" v-if="good.priceType !== 'CUSTOM' && (good.yield || treatment)"><span>{{ good.yield || treatment }}</span></div>
          <div
            class="plv-iar-product-bubble__btn"
            :class="{
              'plv-iar-product-bubble__btn--disabled': disabledStatus
            }"
          >
            {{ good.btnShow  }}
            <div v-if="isJobType" class="plv-iar-product-bubble__link">
              <buy-button
                class="plv-iar-product-bubble__link__content"
                :good="good"
                :show-disabled="false"
                @disabled-status-change="disabledStatusChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 点击热区 -->
    <div v-if="!isJobType" class="plv-iar-product-bubble__link">
      <section class="plv-iar-product-bubble__link__content-hot-click" v-show="hotEffectEnabled && hotTimes >= 1" @click="onClickHotClick"></section>
      <section
        class="plv-iar-product-bubble__link__content-cover"
        :class="{
          'plv-iar-product-bubble__link__content-cover__finance': good.productType === 'finance' && !good.cover
        }"
        @click="onClickCover"
      ></section>
      <buy-button
        class="plv-iar-product-bubble__link__content-btn"
        :good="good"
        :show-disabled="false"
        @disabled-status-change="disabledStatusChange"
      />
    </div>

    <buy-button
      v-if="redirectDirectlyEnabled"
      :good="good"
      :is-cover-all="true"
    />

    <!-- 关闭按钮 -->
    <div
      class="plv-iar-product-bubble__close"
      :class="{
        'plv-iar-product-bubble__close2': hotEffectEnabled && hotTimes >= 1
      }"
      @click.stop="$emit('click-close')"
    ></div>
  </div>
</template>

<script>
import goodMixin from '../good-mixin';
import BuyButton from '../BuyButton/BuyButton.vue';
import HotTimeLabel from '../hotTimesLabel';

export default {
  components: {
    BuyButton,
    HotTimeLabel
  },

  props: {
    hotEffectTipOption: {
      type: Object,
      default: () => ({})
    },
    hotEffectEnabled: {
      type: Boolean,
      default: false
    }
  },

  mixins: [goodMixin],

  data() {
    return {
      disabledStatus: false,
    };
  },

  methods: {
    disabledStatusChange(status) {
      this.disabledStatus = status;
    },

    onClick() {
      if (this.isJobType) {
        this.$emit('job-detail', this.good);
      }
    },

    onClickCover() {
      this.$emit('click-cover', this.good);
    },

    onClickHotClick() {
      this.$emit('click-hot-click', this.good);
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/styles/basic.scss';

.plv-iar-product-bubble__bubble-main {
  position: relative;
  width: 100%;
  box-sizing: border-box;

  .plv-iar-product__buy-button--cover-all {
    z-index: 30;
  }
}

.plv-iar-product-bubble__bubble—container {
  border-radius: 4px;
  padding: 2px;
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, .1);
  background-image: url(./imgs/bubble-bg.png);
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: 52px auto;
  overflow: hidden;
}

.plv-iar-product-bubble__cover {
  width: 100px;
  margin-bottom: 2px;
  position: relative;
  font-size: 0;
  border-radius: 4px;
  overflow: hidden;

  & > img {
    width: 100%;
    height: 100px;
    object-fit: cover;
  }

  &:not(.plv-iar-product-bubble__nocover) {
    .plv-iar-product-bubble__content__labels {
      position: absolute;
      bottom: 3px;
      left: 3px;
      background: #F15D5D;
      color: #fff;
    }
  }

  .plv-iar-product-bubble__cover__sold-out {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
  }

  .plv-iar-product-bubble__cover__number {
    position: absolute;
    left: 0;
    width: 19px;
    height: 17px;
    line-height: 17px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px 0 6px 0;
    background: #F15D5D;
  }

  .plv-iar-product-bubble__content__labels {
    display: inline-block;
    height: 16px;
    color: #F15D5D;
    border: 1px solid #F15D5D;
    font-size: 12px;
    border-radius: 2px;
    line-height: 16px;
    >i {
      display: inline-block;
      transform: scale(0.8334);
      transform-origin: center;
      font-style: normal;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 80px;
    }
  }

  &.plv-iar-product-bubble__nocover {
    padding-top: 8px;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 6px;
      border-radius: 6px;
      background: #fff;
    }

    .plv-iar-product-bubble__cover__number {
      padding: 4px 0 6px 8px;
      top: -24px;
      right: 0;
      text-align: left;
      width: auto;
      border-radius: 6px 6px 0 0;
    }
    .plv-iar-product-bubble__explaining--nocover {
      padding: 9px 0 8px 8px;
      top: -34px;
      left: -2px;
      text-align: left;
      border-radius: 4px 6px 0 0;
      width: 100%;
      background: #F15D5D;
    }
  }

  &.plv-iar-product-bubble__margin {
    margin-top: 24px;
  }
}

.plv-iar-product-bubble__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.plv-iar-product-bubble__content__name {
  font-size: 12px;
  line-height: 17px;
  margin-bottom: 2px;
  color: #333;

  &:not(.plv-iar-product-bubble__content__name__multline) {
    @include text-singleline;
  }

  &.plv-iar-product-bubble__content__name__multline {
    @include text-multiline;
  }
}

.plv-iar-product-bubble__content_custom_price {
  font-size: 12px;
  line-height: 17px;
  color: #FF6363;
  overflow: hidden;
  word-break: break-all;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90px;
}

.plv-iar-product-bubble__content__price {
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 17px;
  color: #FF6363;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.plv-iar-product-bubble__content__bottom {
  margin-top: auto;
  width: 100%;
  display: flex;
  align-items: center;
}
.plv-iar-product-bubble__content__oldprice {
  color: #B2B2B2;
  font-size: 12px;
  line-height: 16px;
  margin-left: 2px;
  margin-right: 8px;
  text-decoration: line-through;
  flex: 1;
  @include text-singleline;
}

.plv-iar-product-bubble__btn {
  position: relative;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #F15D5D;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  &.plv-iar-product-bubble__btn--disabled {
    opacity: 0.5;
  }

  &.plv-iar-product-bubble__btn__normal {
    padding-left: 3px;
    text-align: left;
    background-image: url(./imgs/icon-buy.png);
    background-position: right center;
    background-repeat: no-repeat;
    background-size: auto 100%;
  }
}

.plv-iar-product-bubble__link {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
}

.plv-iar-product-bubble__link__content-hot-click {
  width: 100%;
  height: 24px;
}

.plv-iar-product-bubble__link__content-cover {
  width: 100%;
  height: 100px;
}
.plv-iar-product-bubble__link__content-cover__finance {
  height: 80px;
}

.plv-iar-product-bubble__link__content-btn {
  width: 100%;
  flex: 1;
}

.plv-iar-product-bubble__close {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  background-image: url(./imgs/icon-bubble-close.png);
  background-size: 60% 60%;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 30;

  &.plv-iar-product-bubble__close2 {
    top: 33px;
  }
}

.plv-iar-product__item__btn__content {
  display: block;
  min-width: 72px;
  height: 28px;
  line-height: 28px;
  border-radius: 4px;
  color: #fff;
  background: #FF6666;
  font-size: 14px;
  text-decoration: none;
  outline: none;
  position: relative;
  padding: 0 8px;
  box-sizing: border-box;
  text-align: center;
}

.plv-iar-product-bubble__explaining {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  border-radius: 4px 0 8px 0;
  background: rgba(0, 0, 0, 0.6);
  color: #FFFFFF;
  font-size: 12px;
  zoom: 0.8;
}

.plv-iar-product-bubble__explaining__icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  vertical-align: top;
}

.plv-iar-product__item__price-symbol {
  font-size: 12px;
  color: #FF5252;
}

.plv-iar-product__item__price-value {
  font-size: 18px;
  color: #FF5252;
}

.plv-iar-product__item__price-tag {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  display: inline-block;
  margin: 6px 2px 0 3px;
}
</style>
